import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ExternalLink, Copy, Check } from 'lucide-react';
import { useTheme } from '../../lib/theme';
import { SectionShell, SettingsCard, outlineBtn } from './_shared';
import { getEmailForwardAddress } from '../../lib/api';

export default function EmailInboxSection() {
  const { colors } = useTheme();
  const [addr, setAddr] = useState('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await getEmailForwardAddress();
        setAddr(r.address || '');
      } catch { /* noop */ }
    })();
  }, []);

  const copy = async () => {
    if (!addr) return;
    try { await navigator.clipboard.writeText(addr); setCopied(true); setTimeout(() => setCopied(false), 2000); } catch { /* noop */ }
  };

  return (
    <SectionShell eyebrow="Email Inbox & Forwarding" title="Email Inbox & Forwarding" description="Forward receipts straight to Clasifi — we'll OCR, categorize, and queue them for review." testid="section-email">
      <SettingsCard title="Your forwarding address" description="This address is unique to your account. Set a mail rule from your receipts inbox to it." testid="email-forward-card">
        <div style={{
          display: 'flex', gap: 10, alignItems: 'center',
          padding: 14, borderRadius: 10, background: colors.accentSoft, color: colors.text,
        }}>
          <Mail size={18} color={colors.accent} />
          <code style={{ flex: 1, fontSize: 14, fontWeight: 700, color: colors.text }} data-testid="forward-address">
            {addr || 'Loading…'}
          </code>
          <button
            type="button"
            onClick={copy}
            data-testid="forward-address-copy"
            disabled={!addr}
            style={{ ...outlineBtn(colors), display: 'inline-flex', alignItems: 'center', gap: 6, padding: '6px 10px', fontSize: 12 }}
          >
            {copied ? <Check size={13} /> : <Copy size={13} />}
            {copied ? 'Copied' : 'Copy'}
          </button>
        </div>
        <div style={{ marginTop: 16, color: colors.textMuted, fontSize: 13, lineHeight: 1.6 }}>
          <strong style={{ color: colors.text }}>Gmail:</strong> Settings → Forwarding and POP/IMAP → add forwarding address → verify.<br />
          <strong style={{ color: colors.text }}>Outlook:</strong> Settings → Mail → Rules → Add new rule → Forward to the address above.
        </div>
      </SettingsCard>

      <SettingsCard title="Inbox activity" description="See every email that landed in your Clasifi inbox." testid="email-inbox-card">
        <Link to="/app/inbox" data-testid="go-to-inbox" style={{ ...outlineBtn(colors), display: 'inline-flex', alignItems: 'center', gap: 8, textDecoration: 'none' }}>
          Open Inbox <ExternalLink size={14} />
        </Link>
      </SettingsCard>
    </SectionShell>
  );
}
